import React from 'react';
import { Outlet } from 'react-router-dom';
import { PageHeader } from '@ui';
import useTranslation from '@app/hooks/use-translation';
import UsersNavigationBlock from '@app/pages/users/blocks/users-navigation.block';

const UsersOutlet = () => {
  const { t } = useTranslation('pages.usersPage');

  return (
    <div>
      <PageHeader icon="UserIcon" label={t('pageTitle')} />
      <UsersNavigationBlock />
      <Outlet />
    </div>
  );
};

export default UsersOutlet;
